import React from "react";
import PropTypes from "prop-types";

const BalloonString = ({ balloonClass }) => (
    <svg
        className={balloonClass}
        width="16px"
        height="40px"
        viewBox="0 0 16 40"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs />
        <g
            id="V2_Design"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="12-Col_7683_homepage"
                transform="translate(-61.000000, -1550.000000)"
                stroke="#172456"
            >
                <path
                    d="M67.5758025,1550 C71.3434546,1554.28833 79.301986,1558.42727 74.5063567,1565.19279 C71.0934843,1570.00755 53.2526374,1582.39191 67.3464972,1589"
                    id="Path-2-Copy-10"
                />
            </g>
        </g>
    </svg>
);

BalloonString.propTypes = {
    balloonClass: PropTypes.string
};

export default BalloonString;



// WEBPACK FOOTER //
// ./src/components/landingPage/BalloonString.jsx